import { createMuiTheme } from 'material-ui-next/styles'
import pink from 'material-ui-next/colors/pink'
import red from 'material-ui-next/colors/red'
import cyan from 'material-ui-next/colors/cyan'
import { themeColors } from './theme'

const dimensions = {
  toolbar: 52,
  secondaryToolbar: 56,
  toolbarExpanded: 200,
  filtersToolbar: 80,
  // filtersToolbar: 160,
  scaleFiltersDimension: 'scale(0.8, 0.8)',
}

const colors = {
  positive: '#00b4bc',
  assertive: '#F57170',
  energized: '#364f6b',
  neutral: '#9C9B9B',
  white: '#fff',
  lightblack: '#444',
  darkpositive: '#006c70',
  lightpositive: '#ccf0f1',
  evilred: '#DC143C',
  footergrey: '#efefef',
  labelgrey: '#BDBDBD',
  mediumgrey: '#B1B1B1',
  tomato: '#eb6651',
  light: '#e5f7f8',
  secondaryToolbar: 'rgb(232, 232, 232)',
  //material-ui colors
  primary: '#00BCD4',
  secondary: '#FF4081',

  //amazon color
  amazon: '#FEBD69',

  //#TODO: work on these..
  positiveFont: '#fff',
  lightBackground: '#eee',
}

const theme = createMuiTheme({
  palette: {
    primary: cyan,
    secondary: {
      ...pink,
      A400: '#00e677',
    },
    error: red,
  },
  typography: {
    fontFamily: 'Roboto, sans-serif!important',
    subheading: {
      fontSize: 16,
    },
    button: {
      fontSize: 14,
    },
  },
  swapick: {
    colors,
    dimensions,
    styles: {
      general: {
        padding5: {
          padding: 5,
        },
      },
      toolbars: {
        secondaryToolbar: {
          minHeight: dimensions.secondaryToolbar,
          height: dimensions.secondaryToolbar,
          backgroundColor: colors.secondaryToolbar,
        },
        toolbarGroup: {
          display: 'inline-flex',
          height: '100%',
          alignItems: 'center',
        },
      },
      dropdown: {
        menuItem: {
          textTransform: 'uppercase',
          fontSize: 13,
          letterSpacing: '.8px',
          padding: '0px 24px',
          textDecoration: 'none',
          paddingRight: '46px',
          fontWeight: 500,
          height: '32px',
        },
      },
      infoText: {
        titles: {
          color: themeColors.positive,
          fontSize: 20,
          '-webkit-margin-before': '1.33em',
          '-webkit-margin-after': '1.33em',
          fontWeight: 'bold',
        },
        titleIcon: {
          color: `${themeColors.positive}!important`,
          position: 'relative',
          top: 5,
          marginRight: 10,
        },
        subtitles: {
          fontSize: 18,
          color: themeColors.energized,
          marginTop: 10,
          marginBottom: 10,
          fontWeight: 'bold',
          lineHeight: 1.5,
        },
        info: {
          fontSize: 16,
          lineHeight: 1.5,
          display: 'block',
          fontFamily: 'Roboto, sans-serif!important',
        },
        divider: {
          marginTop: 100,
          marginBottom: 50,
        },
        paper: {
          padding: 20,
          margin: 'auto',
          marginBottom: 30,
        },
        positive: {
          color: themeColors.positive,
        },
        tableTitle: {
          color: themeColors.secondary,
          fontSize: 14,
        },
        tableRow: {
          height: 'none',
          minHeight: '48px',
        },
        tableRight: {
          textOverflow: 'clip',
          whiteSpace: 'normal',
        },
        tableLeft: {
          fontWeight: 'bold',
        },
        question: {
          color: themeColors.energized,
          fontSize: 16,
        },
        answer: {
          fontStyle: 'italic',
          color: themeColors.neutral,
          fontSize: 16,
        },
        underPositive: {
          textDecoration: 'underline',
          textDecorationColor: themeColors.positive,
        },
        underSecondary: {
          textDecoration: 'underline',
          textDecorationColor: themeColors.secondary,
        },
      },
    },
  },
})

export default theme



// WEBPACK FOOTER //
// ./src/styles/swapickTheme.js